import { BusVehicleTypeFeaturePage } from "..";

/** 大巴车型字典业务路由。 */
export function BusVehicleTypePage() {
  return <BusVehicleTypeFeaturePage />;
}
